import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import "../styles/Servicesnew.css";

// Service images
import ser1 from "../assets/ser1.jpeg";
import ser2 from "../assets/ser2.jpeg";
import ser3 from "../assets/ser3.jpeg";
import ser4 from "../assets/ser4.jpeg";
import ser5 from "../assets/ser5.jpeg";
import ser6 from "../assets/ser6.jpeg";
import ser7 from "../assets/ser7.jpeg";
import ser8 from "../assets/ser8.jpeg";
import ser9 from "../assets/ser9.jpeg";
import ser11 from "../assets/ser11.jpeg";

// Hero videos
import servicesHeroVideo from "../assets/services-hero-data.mp4";
import servicesHeroVideo1 from "../assets/services1.mp4";
import servicesHeroVideo2 from "../assets/services2.mp4";
// Keep this because your existing hero CSS uses these classes


/* =========================================================
   TECHLYNX SERVICES DATA
   ========================================================= */

export const serviceData = [
  {
    title: "IT Services & Solutions",
    description:
      "We architect full-stack web applications, microservices, and enterprise software designed for high availability, security, and effortless scalability. Our technology stack includes React, Next.js, Python, Java, and Go.",
    tags: ["Java", " Python", "React", "Node.js", "SQL"],
    image: ser1,
    button: "Explore IT Services & Solutions",
    url: "/services/it-services",
  },

  {
    title: "AI Workstations & AI Film Making",
    description:
      "We provide AI-ready workstations for demanding creative workflows and support film production with AI-assisted research, storyboarding, visual development, and post-production tools. Our team helps creators use AI while keeping creative direction in human hands.",
    tags: ["AI", " ML", "Generative AI"],
    image: ser2,
    button: "Explore AI & Film Services",
    url: "/services/ai-work-film",
  },

  {
    title: "Cloud Platforms",
    description:
      "Plan, migrate, and manage cloud environments built around your applications and data. We help teams improve scalability, security, and reliability across cloud infrastructure and deployment workflows.",
    tags: ["AWS", "Azure", "GCP"],
    image: ser3,
    button: "Explore Cloud Platforms",
    url: "/services/cloud-platforms",
  },

  {
    title: "Cyber Security",
    description:
      "Protect your systems and information with security reviews, access controls, vulnerability checks, and practical risk reduction. We help teams strengthen applications and respond to security issues with confidence.",
    tags: ["VPN", "IDS", "Firewall", "Encryption Systems"],
    image: ser4,
    button: "Explore Cyber Security",
    url: "/services/cyber-security",
  },

  {
    title: "Digital Marketing",
    description:
      "Grow your online reach with campaign planning, search and social media marketing, content, and performance tracking. We help businesses connect with the right audiences and improve marketing results over time.",
    tags: ["SEO", "Google Ads", "Analytics", "Meta Ads"],
    image: ser5,
    button: "Explore Digital Marketing",
    url: "/services/digital-marketing",
  },

  {
    title: "BPO Service",
    description:
      "Support daily business operations with dependable business process outsourcing. We can assist with customer support, data processing, back-office administration, and other repeatable workflows tailored to your needs.",
    tags: ["CRM", "IDP", "RPA"],
    image: ser6,
    button: "Explore BPO Services",
    url: "/services/bpo",
  },

  {
    title: "HR and Payroll Services",
    description:
      "Manage essential HR and payroll processes, including employee records, attendance coordination, payroll preparation, and reporting. We help businesses keep people operations organized and accurate.",
    tags: ["HRMS", "Payroll Software", "ADP", "SAP HCM"],
    image: ser7,
    button: "Explore HR & Payroll",
    url: "/services/hr-payroll",
  },

  {
    title: "Man Powering",
    description:
      "Find and place qualified professionals for the roles your business needs. We support candidate sourcing, screening, onboarding coordination, and workforce planning for short-term and ongoing requirements.",
    tags: [
      "Recruitment",
      "Talent Acquisition",
      "Candidate Sourcing",
      "Screening",
      "Staffing",
    ],
    image: ser8,
    button: "Explore Manpowering",
    url: "/services/manpowering",
  },

  {
    title: "Internship and Training",
    description:
      "Prepare students and early-career professionals for the workplace through practical training, guided projects, and mentorship. Programs can cover software development, digital tools, and essential professional skills.",
    tags: [
      "SAP",
      ".NET",
      "GitHub",
      "Web Development",
      "Spring Boot",
    ],
    image: ser9,
    button: "Explore Internship & Training",
    url: "/services/internship-training",
  },

  {
    title: "CA and Taxation",
    description:
      "Support accounting and financial operations with bookkeeping, account reconciliation, tax preparation assistance, and financial reporting. Services are shaped around each client's records, deadlines, and compliance needs.",
    tags: ["Accounting", "GST", "Tally", "Financial Reporting"],
    image: ser11,
    button: "Explore Financial Services",
    url: "/services/ca-financial-services",
  },
];

/* =========================================================
   SERVICES COMPONENT
   ========================================================= */

export default function Services() {
  const [flippedBottomCard, setFlippedBottomCard] = useState(null);

  const navigate = useNavigate();

  /* =========================================================
     SERVICE BUTTON NAVIGATION
     ========================================================= */

  const handleExplore = (service) => {
    const destination =
      service.url ??
      serviceData.find(({ title }) => title === service.title)?.url;

    if (destination) {
      navigate(destination);
    }
  };

  /* =========================================================
     SERVICES HERO CAROUSEL
     
     IMPORTANT:
     You can replace/add videos inside this array.
     
     type: "video"  -> video carousel slide
     type: "image"  -> image carousel slide
     ========================================================= */

  const slides = [
    {
      id: 1,
      type: "video",
      video: servicesHeroVideo,
      tag: "TECHNOLOGY CAPABILITIES",
      title: "Technology That",
      highlight: "Moves Business Forward.",

      description:
        "From software engineering and cloud infrastructure to AI, automation, data intelligence and security — Techlynx connects technology capabilities into practical business systems.",

      primaryButton: "Explore Services",
      primaryLink: "/services",

      secondaryButton: "Talk to Us",
      secondaryLink: "/contact",

      overlayRgb: "5, 11, 31",
    },

    {
      id: 2,
      type: "video",
      video: servicesHeroVideo1,

      tag: "DIGITAL INNOVATION",
      title: "Build Smarter.",
      highlight: "Scale Faster.",

      description:
        "Transform your business with modern software, cloud technologies, AI, automation and intelligent digital experiences.",

      primaryButton: "Explore Solutions",
      primaryLink: "/services",

      secondaryButton: "Talk to Us",
      secondaryLink: "/contact",

      overlayRgb: "5, 11, 31",
    },

    {
      id: 3,
      type: "video",
      video: servicesHeroVideo2,

      tag: "DIGITAL INNOVATION",
      title: "Build Smarter.",
      highlight: "Scale Faster.",

      description:
        "Transform your business with modern software, cloud technologies, AI, automation and intelligent digital experiences.",

      primaryButton: "Explore Solutions",
      primaryLink: "/services",

      secondaryButton: "Talk to Us",
      secondaryLink: "/contact",

      overlayRgb: "5, 11, 31",
    },
  ];

  /* =========================================================
     CAROUSEL STATE
     ========================================================= */

  const [currentSlide, setCurrentSlide] = useState(0);

  /* =========================================================
     AUTOMATIC CAROUSEL
     ========================================================= */

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((previous) =>
        previous === slides.length - 1 ? 0 : previous + 1
      );
    }, 6000);

    return () => clearInterval(timer);
  }, [slides.length]);

  /* =========================================================
     NEXT SLIDE
     ========================================================= */

  const nextSlide = () => {
    setCurrentSlide((previous) =>
      previous === slides.length - 1 ? 0 : previous + 1
    );
  };

  /* =========================================================
     PREVIOUS SLIDE
     ========================================================= */

  const previousSlide = () => {
    setCurrentSlide((previous) =>
      previous === 0 ? slides.length - 1 : previous - 1
    );
  };

  /* =========================================================
     MAIN PAGE
     ========================================================= */

  return (
    <main className="services-page">

      {/* =====================================================
          HERO CAROUSEL
          ===================================================== */}

      <section className="hero-carousel">

        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${
              index === currentSlide ? "hero-slide-active" : ""
            }`}
            style={{
              "--hero-overlay-rgb": slide.overlayRgb,
            }}
          >

            {/* =================================================
                VIDEO BACKGROUND
                ================================================= */}

            {slide.type === "video" && index === currentSlide && (
              <video
                className="hero-video"
                src={slide.video}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              />
            )}

            {/* =================================================
                IMAGE BACKGROUND
                ================================================= */}

            {slide.type === "image" && (
              <div
                className="hero-image"
                style={{
                  backgroundImage: `url(${slide.image})`,
                }}
              />
            )}

            {/* =================================================
                OVERLAY
                ================================================= */}

            <div className="hero-overlay"></div>

            <div className="hero-glow"></div>

            {/* =================================================
                HERO CONTENT
                ================================================= */}

            <div className="hero-content">

              <div className="hero-tag">
                <span className="hero-tag-line"></span>
                {slide.tag}
              </div>

              <h1>
                {slide.title}
                <br />
                <span>{slide.highlight}</span>
              </h1>

              <p>{slide.description}</p>

              <div className="hero-buttons">

                <Link
                  className="hero-primary-btn"
                  to={slide.primaryLink}
                >
                  {slide.primaryButton}
                  <span>→</span>
                </Link>

                <Link
                  className="hero-secondary-btn"
                  to={slide.secondaryLink}
                >
                  {slide.secondaryButton}
                </Link>

              </div>

            </div>
          </div>
        ))}

        {/* =====================================================
            PREVIOUS
            ===================================================== */}

        <button
          className="hero-arrow hero-arrow-left"
          onClick={previousSlide}
          aria-label="Previous slide"
          type="button"
        >
          ‹
        </button>

        {/* =====================================================
            NEXT
            ===================================================== */}

        <button
          className="hero-arrow hero-arrow-right"
          onClick={nextSlide}
          aria-label="Next slide"
          type="button"
        >
          ›
        </button>

        {/* =====================================================
            INDICATORS
            ===================================================== */}

        <div className="hero-indicators">

          {slides.map((slide, index) => (
            <button
              key={slide.id}
              className={`hero-indicator ${
                index === currentSlide ? "hero-indicator-active" : ""
              }`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
              type="button"
            >
              <span></span>
            </button>
          ))}

        </div>

        {/* =====================================================
            COUNTER
            ===================================================== */}

        <div className="hero-counter">

          <span>
            {String(currentSlide + 1).padStart(2, "0")}
          </span>

          <div className="hero-counter-line"></div>

          <span>
            {String(slides.length).padStart(2, "0")}
          </span>

        </div>

      </section>

      {/* =====================================================
          CATEGORY HEADER
          ===================================================== */}

      <section className="services-section">

        <div className="section-header">

          <div className="section-heading">

            <div className="category-label">
              OUR EXPERTISE <span>•</span> TECHNOLOGY &amp; DIGITAL SERVICES
            </div>

            <h2>
              <span className="heading-icon" aria-hidden="true">
                ϟ
              </span>{" "}
              Technology Services
            </h2>

          </div>

          <div className="service-count">
            <span>{serviceData.length}</span>
            <small>Specialized Services</small>
          </div>

        </div>

        {/* =====================================================
            SERVICE CARDS
            ===================================================== */}

        <div className="services-container">

          {serviceData.map((service, index) => (

            <article
              className="service-card"
              key={service.title}
            >

              {/* =================================================
                  IMAGE
                  ================================================= */}

              <div className="service-image-container">

                <img
                  src={service.image}
                  alt={service.title}
                  className="service-image"
                />

                <div className="image-dark-overlay"></div>

              </div>

              {/* =================================================
                  CONTENT
                  ================================================= */}

              <div className="service-info">

                <h3>
                  {service.title}
                </h3>

                <p>
                  {service.description}
                </p>

                <div className="service-tags">

                  {service.tags.map((tag) => (
                    <span key={tag}>
                      {tag}
                    </span>
                  ))}

                </div>

                {/* =================================================
                    BUTTON
                    ================================================= */}

                <button
                  className="service-explore-btn"
                  type="button"
                  onClick={() => handleExplore(service)}
                >
                  {service.button}
                  <span>→</span>
                </button>

              </div>

            </article>

          ))}

        </div>

      </section>

    </main>
  );
}
